export default __webpack_public_path__ + "static/media/Chart-fill.b014b801.svg";